module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-bb.308996d5.png";